"use client";

import React, { useState } from "react";
import { Offer, ProductData } from "@/services/dataTypes";
import { getFinalDiscountTag } from "@/constants/hooks";
import SimpleOfferModal from "./SimpleOfferModal";
import Link from "next/link";

interface Props {
    offer:             Offer | ProductData;
    merchantHref:      string;
    imageSrc:          string;
    merchantImg?:      string | null;
    domain:            string;
    type:              "anchor" | "button";
    buttonClass?:      string;
    isDetail?:         number;           // if 1 → redirect to product detail page
    productDetailUrl?: string | null;    // product detail page URL
}

const OfferDetailsToggle = ({
    offer, merchantHref, domain, type, buttonClass,
    imageSrc, merchantImg, isDetail, productDetailUrl,
}: Props) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const originalPrice   = offer?.original_price ? parseFloat(offer.original_price) : 0;
    const salePrice       = offer?.sale_price      ? parseFloat(offer.sale_price)     : 0;
    const discountPercent = originalPrice > 0 && salePrice > 0
        ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
        : null;

    const finalDiscountTag = getFinalDiscountTag(
        offer?.offer_title || offer?.offer_detail,
        discountPercent,
    );

    const sharedClass = buttonClass ||
        "text-[11px] font-bold text-gray-500 hover:text-[#ff912f] transition-colors duration-300 underline underline-offset-4";

    /* ── If is_detail === 1 AND productDetailUrl exists → Link to detail page ── */
    if (isDetail === 1 && productDetailUrl) {
        return (
            <Link
                href={productDetailUrl}
                className={`no-underline hover:underline underline-offset-2 relative z-[5] ${sharedClass}`}
            >
                View Details
            </Link>
        );
    }

    /* ── Otherwise → open SimpleOfferModal ── */
    return (
        <>
            {type === "anchor" ? (
                <span
                    onClick={handleClick}
                    className={`cursor-pointer select-none ${sharedClass}`}
                >
                    View Details
                </span>
            ) : (
                <button
                    onClick={handleClick}
                    className={`cursor-pointer ${buttonClass || "px-4 py-2 rounded-xl text-[12px] font-bold transition-all duration-300 bg-gray-100 text-gray-600 hover:bg-[#ff912f] hover:text-white"}`}
                >
                    View Details
                </button>
            )}

            {showModal && (
                <SimpleOfferModal
                    data={offer}
                    onClose={() => setShowModal(false)}
                    domain={domain}
                    finalDiscountTag={finalDiscountTag}
                    merchantHref={merchantHref}
                    merchantImg={merchantImg}
                    productImg={imageSrc}
                />
            )}
        </>
    );
};

export default OfferDetailsToggle;
